<template>
  <div>
    <div v-if="token" class="float-right m-2 flex-shrink-0 pt-1">
      <favorite :place="place" />
    </div>
    <div @click="$emit('openPlace', place)" class="p-2 border-section_border flex items-center">
      <!--
      <div class="flex-none w-36">
        <img v-lazy="place.image" class="w-full h-24" />
      </div>
      -->
      <div class="float-left w-7 mr-1">
        <img v-lazy="iconPath(place)" class="w-full" />
      </div>
      <div class="flex-grow ml-2">
        <p>{{ place.name }}</p>
        <p class="text-sm text-btn_secondary">{{ getDistance(center.lat, center.lng, place.location.latitude, place.location.longitude) }}km</p>
        <!--
        <p class="text-sm">{{ place.address }}</p>
        <p v-for="benefit in place.benefits" v-bind:key="benefit.id"
          class="inline-block mt-1 py-1 px-2 border rounded text-sm leading-none border-pass text-pass">
          {{ benefit.name }}
        </p>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Favorite from '../../molecules/Favorite'

export default {
  components: {
    Favorite
  },
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  methods: {
    iconPath(place) {
      if (place.mapIcon !== undefined && place.mapIcon.length > 0) {
        return place.mapIcon
      } else if (this.$store.getters['genres/getMapIcon'](place) !== undefined && this.$store.getters['genres/getMapIcon'](place).mapIcon !== undefined) {
        return this.$store.getters['genres/getMapIcon'](place).mapIcon
      } else {
        return require('@/assets/images/place-24px.svg')
      }
    },
    getDistance: function (lat1, lng1, lat2, lng2) {
      lat1 *= Math.PI / 180;
      lng1 *= Math.PI / 180;
      lat2 *= Math.PI / 180;
      lng2 *= Math.PI / 180;
      const d = 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2))
      return Math.ceil(d * 10) / 10;
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken',
      center: 'map/getCenter'
    })
  }
}
</script>
